











import { defineComponent } from '@nuxtjs/composition-api';
import { getAsJSON } from '~/utils/solepro/CmsComponentAggregator';

export default defineComponent({
    props:{
        areaCta: {
            type: String, required: true
        },
        manageScroll:{
            type: Function,
            default:()=>{console.log('default')}
        }
    },
    setup(props){
        const ctasObj = getAsJSON(props.areaCta);
        return {
            ctasObj
        }
    },
    data(){
        return {
            editorialStickyBtn: null
        }
    },
    mounted() {
        try{
            this.editorialStickyBtn = this.ctasObj.children[0].children[0].children.find(btn=>btn.cssClasses.includes('pdp-bottom')).DOMContent.children[0];
            
        }catch(e){
            console.warn('/** no pdp bottom btn choosen from area_cta */')
            this.$emit('useDefaultBottomBtn', true)
        }
    },
    methods:{
        manageScrollCbk(evt){
            evt.preventDefault();
            const $t = this as any; //vscode trick @TODO rwmove and fix linter
            const splitted = $t.editorialStickyBtn.href.split('#');
            if(splitted.length>1) {
                $t.manageScroll(evt)
            }else{
                window.open($t.editorialStickyBtn.href, $t.editorialStickyBtn.dataset.target);
            }
        }
    }
})
